import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Container, Title, SubTitle, List, RoundButton } from '../styled'
import YoutubeQuestioner from '../components/YoutubeQuestioner'
import { useGetVideoByIdQuery, useGetViewsByVideoQuery } from '../store/api'
import { get, map, isEmpty, last, isNumber } from 'lodash'
import { secondsToYoutubeFormat, formatViewDate } from '../helpers/time'

export default function StandalonePlayerScreen() {
  const [viewsPage, setViewsPage] = useState(1)
  const [views, setViews] = useState([])
  const { id } = useParams()
  const videoQuery = useGetVideoByIdQuery(id, { skip: !id })
  const videoData = get(videoQuery, 'data') || {}

  const viewsQuery = useGetViewsByVideoQuery({ videoId: id, page: viewsPage }, { skip: !id })
  const hasMoreViews = get(viewsQuery, 'data.nextPage')
  const { isLoading: isLoadingViews, data: viewsData } = viewsQuery
  const { title, questions, videoId } = videoData

  useEffect(() => {
    const newViews = get(viewsQuery, 'data.data')
    const isNewRequest = get(last(views), '_id') !== get(last(newViews), '_id')

    if (isNewRequest) {
      setViews(p => p.concat(newViews))
    }
  }, [viewsQuery, views])

  return (
    <Container>
      <Title>{title}</Title>
      <Container.Row>
        <Container.Column halfColumnLarge>
          <YoutubeQuestioner youtubeId={videoId} questions={questions} />
        </Container.Column>
        <Container.Column halfColumnLarge>
          {!isEmpty(questions) ? (
            <>
              <SubTitle>Questions in this video</SubTitle>
              <List>
                {map(questions, question => (
                  <List.Item key={question.questionId}>
                    <List.ItemBullet>{secondsToYoutubeFormat(question.time)}</List.ItemBullet>
                    <List.ItemText>{question.text}</List.ItemText>
                  </List.Item>
                ))}
              </List>
            </>
          ) : null}
          {isNumber(viewsData?.totalViews) ? (
            <SubTitle>Viewed {viewsData?.totalViews} times</SubTitle>
          ) : null}
          {!isEmpty(views) ? (
            <>
              <List>
                {map(views, view => (
                  <List.Item key={view._id}>
                    <List.ItemBullet>
                      {formatViewDate(view?.date)} by {view.user}
                    </List.ItemBullet>
                  </List.Item>
                ))}
              </List>
              {hasMoreViews && !isLoadingViews ? (
                <RoundButton onClick={() => setViewsPage(page => page + 1)}>Load more</RoundButton>
              ) : null}
            </>
          ) : null}
        </Container.Column>
      </Container.Row>
    </Container>
  )
}
